import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Http from "../../Http";
import { Contact_API } from "../../Helper";

const ContactModal = () => {
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    subject: "",
    email: "",
    message: "",
    phone: "",
  });

  useEffect(() => {
    const isSubmitted = localStorage.getItem("contactFormSubmitted");
    const timer = setTimeout(() => {
      if (!isSubmitted) {
        setShowModal(true);
      }
    }, 10000);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  const handleClose = () => setShowModal(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Always update the form data first
    setFormData((prev) => ({ ...prev, [name]: value }));
    
    // Then perform validation
    if (name === "name") {
      if (value && !/^[A-Za-z\s]*$/.test(value)) {
        setError("Name should contain only letters and spaces");
      } else {
        setError(null);
      }
    }
    
    if (name === "email") {
      if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        setError("Please enter a valid email address");
      } else {
        setError(null);
      }
    }
    
    if (name === "phone") {
      if (value && !/^\d*$/.test(value)) {
        setError("Phone number should contain only digits");
      } else if (value && value.length > 12) {
        setError("Phone number should be 10-12 digits");
      } else {
        setError(null);
      }
    }
  };

  const resetForm = () => {
    setFormData({
      name: "",
      subject: "",
      email: "",
      message: "",
      phone: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Reset any existing errors
    setError(null);

    // Validate all required fields are filled
    if (!formData.name.trim() || !formData.email.trim() || !formData.phone.trim()) {
      setError("Please fill out all fields");
      return;
    }

    // Validate name format
    if (!/^[A-Za-z\s]+$/.test(formData.name)) {
      setError("Name should contain only letters and spaces");
      return;
    }

    // Validate email format
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      setError("Please enter a valid email address");
      return;
    }

    // Validate phone format
    if (!/^\d{10,12}$/.test(formData.phone)) {
      setError("Phone number should be 10-12 digits");
      return;
    }

    // Don't proceed if there's an error
    if (error) return;

    setLoading(true);
    try {
      await Http.post(Contact_API, formData);
      localStorage.setItem("contactFormSubmitted", "true");
      setSuccess(true);
      resetForm();
      setShowModal(false);
    } catch (err) {
      console.error("Submission error:", err);
      setError("Failed to send. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  if (!showModal || success) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 w-[90%] max-w-sm rounded-xl bg-white shadow-lg p-6 animate-slide-up">
      <style>
        {`
          @keyframes slide-up {
            0% { transform: translateY(30%); opacity: 0; }
            100% { transform: translateY(0); opacity: 1; }
          }
          .animate-slide-up {
            animation: slide-up 0.4s ease-out;
          }
        `}
      </style>

      <button
        onClick={handleClose}
        className="absolute top-2 right-3 text-gray-400 hover:text-gray-600 text-xl"
      >
        &times;
      </button>

      <h2 className="text-xl font-bold text-center text-gray-800 mb-1">
        Unlock Smart Savings
      </h2>
      <p className="text-center text-sm text-gray-600 mb-4">
        Get exclusive deals, financial tips & tools straight to your inbox.
      </p>

      <form onSubmit={handleSubmit} className="space-y-3">
        <input
          type="text"
          name="name"
          value={formData.name}
          placeholder="Name"
          onChange={handleChange}
          required
          pattern="[A-Za-z\s]+"
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
        />
        <input
          type="email"
          name="email"
          value={formData.email}
          placeholder="Email Address"
          onChange={handleChange}
          required
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
        />
        <input
          type="tel"
          name="phone"
          value={formData.phone}
          placeholder="Phone Number"
          onChange={handleChange}
          required
          pattern="[0-9]{10,12}"
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
        />
        <p className="text-sm text-gray-500">Get offers via WhatsApp too!</p>
        {error && <p className="text-red-500 text-sm">{error}</p>}
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-md font-medium transition duration-200"
        >
          {loading ? "Sending..." : "Submit"}
        </button>
      </form>

      <p className="text-xs text-gray-400 text-center mt-3 flex items-center justify-center gap-1">
        <span>🔒</span> We respect your privacy. No spam, ever.
      </p>
    </div>
  );
};

export default ContactModal;

// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import Http from "../../Http";
// import { Contact_API } from "../../Helper";

// const ContactModal = () => {
  // const location = useLocation();
  // const [showModal, setShowModal] = useState(false);
  // const [loading, setLoading] = useState(false);
  // const [success, setSuccess] = useState(false);
  // const [error, setError] = useState(null);
  // const [formData, setFormData] = useState({
  //   name: "",
  //   subject: "",
  //   email: "",
  //   message: "",
  //   phone: "",
  // });

  // useEffect(() => {
  //   const isSubmitted = localStorage.getItem("contactFormSubmitted");
  //   const timer = setTimeout(() => {
  //     if (!isSubmitted) {
  //       setShowModal(true);
  //     }
  //   }, 10000);

  //   return () => clearTimeout(timer);
  // }, [location.pathname]);

  // const handleClose = () => setShowModal(false);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "name" && !/^[A-Za-z\s]*$/.test(value)) {
  //     setError("Name should contain only letters and spaces.");
  //     return;
  //   }

  //   if (name === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
  //     setError("Please enter a valid email address.");
  //     return;
  //   }

  //   if (name === "phone" && !/^\d{10,12}$/.test(value)) {
  //     setError("Please enter a valid phone number with 10 to 12 digits.");
  //     return;
  //   }

  //   setError(null);
  //   setFormData((prev) => ({ ...prev, [name]: value }));
  // };

  // const resetForm = () => {
  //   setFormData({
  //     name: "",
  //     subject: "",
  //     email: "",
  //     message: "",
  //     phone: "",
  //   });
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (Object.values(formData).some((field) => !field.trim())) {
  //     setError("Please fill out all fields.");
  //     return;
  //   }

  //   if (error) return;

  //   setLoading(true);
  //   try {
  //     await Http.post(Contact_API, formData);
  //     localStorage.setItem("contactFormSubmitted", "true");
  //     setSuccess(true);
  //     resetForm();
  //     setShowModal(false);
  //   } catch (err) {
  //     console.error("Submission error:", err);
  //     setError("Failed to send. Please try again later.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // if (!showModal || success) return null;

//   return (
//     <>
//       <style>
//         {`
//           @keyframes slideUp {
//             0% { transform: translateY(50%); opacity: 0; }
//             100% { transform: translateY(0); opacity: 1; }
//           }
//           .animate-slide-up {
//             animation: slideUp 0.4s ease-out;
//           }
//         `}
//       </style>

      // <div className="fixed bottom-4 right-4 z-50">
      //   <div className="bg-white dark:bg-gray-900 w-80 rounded-xl shadow-xl p-5 animate-slide-up relative">
      //     <button
      //       onClick={handleClose}
      //       className="absolute top-3 right-3 text-gray-500 hover:text-red-500 text-xl font-bold"
      //     >
      //       &times;
      //     </button>

//           <h3 className="text-xl font-semibold mb-4 text-center text-gray-800 dark:text-white">
//             Contact Us 📞
//           </h3>

//           <form onSubmit={handleSubmit} className="space-y-3">
//             <input
//               type="text"
//               name="name"
//               value={formData.name}
//               placeholder="Your Name"
//               onChange={handleChange}
//               required
//               className="w-full p-2.5 border border-gray-300 rounded-md dark:bg-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//             <input
//               type="email"
//               name="email"
//               value={formData.email}
//               placeholder="Email"
//               onChange={handleChange}
//               required
//               className="w-full p-2.5 border border-gray-300 rounded-md dark:bg-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//             <input
//               type="text"
//               name="phone"
//               value={formData.phone}
//               placeholder="Phone Number"
//               onChange={handleChange}
//               required
//               className="w-full p-2.5 border border-gray-300 rounded-md dark:bg-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//             <textarea
//               name="message"
//               value={formData.message}
//               placeholder="Message"
//               rows="3"
//               onChange={handleChange}
//               required
//               className="w-full p-2.5 border border-gray-300 rounded-md dark:bg-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
            // {error && <p className="text-red-500 text-sm">{error}</p>}
//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full bg-blue-600 hover:bg-blue-700 transition duration-200 text-white py-2 rounded-md"
//             >
//               {loading ? "Sending..." : "Submit"}
//             </button>
//           </form>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ContactModal;


// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import Http from "../../Http";
// import { Contact_API } from "../../Helper";

// const ContactModal = () => {
//   const location = useLocation();
//   const [showModal, setShowModal] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [success, setSuccess] = useState(false);
//   const [error, setError] = useState(null);
//   const [formData, setFormData] = useState({
//     name: "",
//     subject: "",
//     email: "",
//     message: "",
//     phone: "",
//   });

//   // Delay modal display for 10 seconds
//   useEffect(() => {
//     const isSubmitted = localStorage.getItem("contactFormSubmitted");
//     const timer = setTimeout(() => {
//       if (!isSubmitted) {
//         setShowModal(true);
//       }
//     }, 10000); // 10 seconds

//     return () => clearTimeout(timer);
//   }, [location.pathname]);

//   const handleClose = () => setShowModal(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "name" && !/^[A-Za-z\s]*$/.test(value)) {
//       setError("Name should contain only letters and spaces.");
//       return;
//     }

//     if (name === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
//       setError("Please enter a valid email address.");
//       return;
//     }

//     if (name === "phone" && !/^\d{10,12}$/.test(value)) {
//       setError("Please enter a valid phone number with 10 to 12 digits.");
//       return;
//     }

//     setError(null);
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const resetForm = () => {
//     setFormData({
//       name: "",
//       subject: "",
//       email: "",
//       message: "",
//       phone: "",
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (Object.values(formData).some((field) => !field.trim())) {
//       setError("Please fill out all fields.");
//       return;
//     }

//     if (error) return;

//     setLoading(true);
//     try {
//       const response = await Http.post(Contact_API, formData);
//       localStorage.setItem("contactFormSubmitted", "true");
//       setSuccess(true);
//       resetForm();
//       setShowModal(false);
//     } catch (err) {
//       console.error("Submission error:", err);
//       setError("Failed to send. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (!showModal || success) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
//       <div className="bg-white dark:bg-gray-900 w-[90%] max-w-md rounded-xl shadow-2xl p-6 relative animate-fade-in">
//         {/* Close Button */}
//         <button
//           onClick={handleClose}
//           className="absolute top-3 right-4 text-gray-600 hover:text-red-500 text-2xl font-bold"
//         >
//           &times;
//         </button>

//         <h3 className="text-2xl font-bold mb-5 text-center text-gray-800 dark:text-white">
//           Contact Us 📞
//         </h3>

//         <form onSubmit={handleSubmit} className="space-y-4">
//           <input
//             type="text"
//             name="name"
//             value={formData.name}
//             placeholder="Your Name"
//             onChange={handleChange}
//             required
//             className="w-full p-3 border border-gray-300 rounded-lg dark:bg-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
//           />
//           <input
//             type="email"
//             name="email"
//             value={formData.email}
//             placeholder="Email"
//             onChange={handleChange}
//             required
//             className="w-full p-3 border border-gray-300 rounded-lg dark:bg-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
//           />
//           <input
//             type="text"
//             name="phone"
//             value={formData.phone}
//             placeholder="Phone Number"
//             onChange={handleChange}
//             required
//             className="w-full p-3 border border-gray-300 rounded-lg dark:bg-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
//           />
//           <textarea
//             name="message"
//             value={formData.message}
//             placeholder="Message"
//             rows="3"
//             onChange={handleChange}
//             required
//             className="w-full p-3 border border-gray-300 rounded-lg dark:bg-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
//           />
//           {error && <p className="text-red-500 text-sm">{error}</p>}
//           <button
//             type="submit"
//             disabled={loading}
//             className="w-full bg-blue-600 hover:bg-blue-700 transition duration-200 text-white py-2.5 rounded-lg"
//           >
//             {loading ? "Sending..." : "Submit"}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ContactModal;


